export const shouldDisplayMarker = (
  sections: string[],
  savedSections: string[],
): boolean => {
  return sections.some((section) =>
    savedSections.some((saved) => saved === section),
  );
};
